module.exports = __webpack_public_path__ + "static/media/invoice.350c2446.png";